module.exports = __webpack_public_path__ + "static/media/pdf.d74a9f95.svg";


//////////////////
// WEBPACK FOOTER
// ./src/App/scenes/AppFrame/scenes/Files/images/pdf.svg
// module id = 602
// module chunks = 0